import update from 'immutability-helper';
import { deepFreeze } from 'utils/deepFreeze';

import { ADD_ALL_ITEMS_FULFILLED } from 'redux/modules/add-all-items/actions/types';
import { GET_BOUGHT_IN_STORE_PRODUCTS } from 'redux/modules/bought-in-store/actions/types';
import { GET_FAVOURITES } from 'redux/modules/favourites-experience/actions/types';
import { GET_MORE_OF_WHAT_YOU_LOVE_SUGGESTIONS } from 'redux/modules/more-of-what-you-love/actions/types';
import { GET_QUICK_SHOP_SUGGESTIONS } from 'redux/modules/quick-shop/actions/types';
import { GET_SHOP_BY_LIST_SUGGESTIONS } from 'redux/modules/shop-by-list/actions/types';
import { GET_ORDER_PRODUCTS_LOADED } from 'redux/modules/orders/actions/types';
import {
  INVALIDATEPRODUCTS,
  LOADED as SEARCHANDBROWSE_PRODUCTS_LOADED,
  NEXTLOADED as SEARCHANDBROWSE_PRODUCTS_NEXTLOADED,
  OFFER_PRODUCTS_LOADED,
} from 'redux/modules/search-and-browse/actions/types';
import { GET_MEAL_DEAL } from 'redux/modules/meal-deals/actions/types';
import { INTERSTITIALS_FULFILLED } from 'redux/modules/interstitials/actions/types';
import {
  ORDER_LOADED,
  REMOVE_ITEM_FROM_TROLLEY,
  REMOVE_MULTIPLE_ITEMS_FROM_TROLLEY,
} from 'redux/modules/trolley/actions/types';
import { SHOPPING_LIST_PRODUCTS_FULFILLED } from 'redux/modules/shopping-list/actions/types';
import { EXPERIENCE_FRAGMENT_SUBMIT_SUCCESS } from 'redux/modules/experience-fragments/actions/types';

import {
  componentsAndProductsSchema,
  experienceFragmentSchema,
  intelligentShoppingExperienceSuggestionsSchema,
  productsSchema,
  suggestionsSchema,
} from 'redux/schemas';

import getNormalisedProductConflicts from './get-normalised-product-conflicts';
import getNormalisedTrolleyConflicts from './get-normalised-trolley-conflicts';

const initialState = () =>
  deepFreeze({
    products: {},
    trolley: {},
  });

export default function reducer(state = initialState(), action = {}) {
  const { result, type } = action;

  switch (type) {
    case GET_ORDER_PRODUCTS_LOADED:
    case OFFER_PRODUCTS_LOADED:
    case SHOPPING_LIST_PRODUCTS_FULFILLED:
    case INTERSTITIALS_FULFILLED:
    case GET_MEAL_DEAL.success: {
      return {
        ...state,
        products: update(state.products, {
          $merge: getNormalisedProductConflicts(result, productsSchema),
        }),
      };
    }
    case ADD_ALL_ITEMS_FULFILLED: {
      return result
        ? {
            ...state,
            products: update(state.products, {
              $merge: getNormalisedProductConflicts(result.trolley, productsSchema),
            }),
          }
        : state;
    }
    case ORDER_LOADED: {
      const { trolley } = result ?? {};
      return trolley
        ? {
            ...state,
            trolley: getNormalisedTrolleyConflicts(trolley),
          }
        : state;
    }
    case SEARCHANDBROWSE_PRODUCTS_LOADED:
    case SEARCHANDBROWSE_PRODUCTS_NEXTLOADED:
    case GET_BOUGHT_IN_STORE_PRODUCTS.success:
    case GET_FAVOURITES.success: {
      return {
        ...state,
        products: update(state.products, {
          $merge: getNormalisedProductConflicts(result, componentsAndProductsSchema),
        }),
      };
    }
    case GET_SHOP_BY_LIST_SUGGESTIONS.success: {
      return {
        ...state,
        products: update(state.products, {
          $merge: getNormalisedProductConflicts(
            result,
            intelligentShoppingExperienceSuggestionsSchema,
          ),
        }),
      };
    }
    case GET_MORE_OF_WHAT_YOU_LOVE_SUGGESTIONS.success:
    case GET_QUICK_SHOP_SUGGESTIONS.success: {
      return {
        ...state,
        products: update(state.products, {
          $merge: getNormalisedProductConflicts(result, suggestionsSchema),
        }),
      };
    }
    case INVALIDATEPRODUCTS: {
      return {
        ...state,
        products: {},
      };
    }
    case REMOVE_ITEM_FROM_TROLLEY: {
      const { trolleyItem: { trolleyItemId } = {}, hasHardConflict } = action;
      if (!hasHardConflict) return state;
      return {
        ...state,
        trolley: update(state.trolley, {
          $unset: [trolleyItemId],
        }),
      };
    }
    case REMOVE_MULTIPLE_ITEMS_FROM_TROLLEY: {
      const { trolleyItems = [] } = action;
      const itemIds = trolleyItems.map(({ trolleyItemId }) => trolleyItemId);

      return {
        ...state,
        trolley: update(state.trolley, {
          $unset: itemIds,
        }),
      };
    }
    case EXPERIENCE_FRAGMENT_SUBMIT_SUCCESS: {
      return {
        ...state,
        products: update(state.products, {
          $merge: getNormalisedProductConflicts(result, experienceFragmentSchema),
        }),
      };
    }
    default:
      return state;
  }
}
